<template>
  <v-card class="pa-3" height="100%">
    <h3>Locations</h3>
    <highcharts
      v-if="!loading"
      :constructor-type="'mapChart'"
      :options="mapOptions"
      class="map"
    />
  </v-card>
</template>

<script>
  import api from "../../../api/datadash";
  import { mapState } from "vuex";
  export default {
    data() {
      return {
        loading: true,
        divisionData: [],
        mapOptions: {
          chart: {
            map: "highChartMap",
            height: "650px",
          },
          title: {
            text: "",
          },
          mapNavigation: {
            enabled: true,
            buttonOptions: {
              verticalAlign: "bottom",
            },
          },
          colorAxis: {
            min: 0,
          },
          navigation: {
            buttonOptions: {
              enabled: true, // Enable the toolbar and exporting options
            },
          },
          exporting: {
            enabled: true, // Enable exporting options
            filename: undefined,
            buttons: {
              contextButton: {
                menuItems: ["downloadSVG", "downloadPNG", "downloadCSV"], // Enable SVG and CSV download options
              },
            },
          },
          series: [
            {
              name: "Division",
              states: {
                hover: {
                  color: "#BADA55",
                },
              },
              dataLabels: {
                enabled: true,
                format: "{point.value}",
              },
              allAreas: false,
              data: [],
            },
          ],
        },
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    created() {
      this.initialize();
    },
    methods: {
      async initialize() {
        this.mapOptions.exporting.filename = `project_summary_${
          this.$route.params.id
        }_locations_${new Date().toISOString().slice(0, 10)}`;
        try {
          const { data } = await api.fetchData(
            this.auth.token,
            `dasher-division-report/${this.$route.params.id}`
          );
          for (let i = 0; i < 8; i++) {
            if (data.data.division_overview.labels[i] == "Chattogram") {
              this.mapOptions.series[0].data[i] = [
                "bd-cg",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Rajshahi") {
              this.mapOptions.series[0].data[i] = [
                "bd-rj",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Khulna") {
              this.mapOptions.series[0].data[i] = [
                "bd-kh",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Barisal") {
              this.mapOptions.series[0].data[i] = [
                "bd-ba",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Sylhet") {
              this.mapOptions.series[0].data[i] = [
                "bd-sy",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Dhaka") {
              this.mapOptions.series[0].data[i] = [
                "bd-da",
                data.data.division_overview.series[i],
              ];
            }
            if (data.data.division_overview.labels[i] == "Rangpur") {
              this.mapOptions.series[0].data[i] = [
                "bd-rp",
                data.data.division_overview.series[i],
              ];
            }
            // if (data.data.division_overview.labels[i] == "Mymenshingh") {
            //   this.mapOptions.series[0].data[i] = [
            //     "",
            //     data.data.division_overview.series[i],
            //   ];
            // }
          }
          this.loading = false;
        } catch (e) {
          //   console.log(e);
        }
      },
    },
  };
</script>
<style scoped>
  .map {
    min-height: 500px;
  }
  ::v-deep .highcharts-credits {
    display: none;
  }
</style>
